/**
 * Centralized translations for Hand Hygiene module
 * Contains all labels used across hand hygiene components
 */

export const UserProfileScreenLabels = {
    it: {
        itemNotFound: 'Elemento non trovato',
        itemNotFoundMessage: `L'elemento richiesto non è stato trovato`,
        goBack: 'Torna indietro',
        success: 'Successo',
        error: 'Errore',
        close: 'Chiudi',
        usersAndGroup: 'Utenti e gruppi',
        groupEditor: 'Editor',
        activeLabel: 'Attivo',
        disactiveLabel: 'Disattivato',
        deleteGroup: 'Elimina gruppo',
        deleteUser: 'Elimina utente',
        deleteGroupConfirm: 'Sei sicuro di voler eliminare il gruppo? Questa azione è irreversibile.',
        deleteUserConfirm: `Sei sicuro di voler eliminare l'utente? Questa azione è irreversibile.`,
        groupDeletedSuccess: 'Gruppo eliminato correttamente',
        groupDeleteError: `Si è verificato un problema durante l'eliminazione del gruppo`,
        userDeletedSuccess: 'Utente eliminato correttamente',
        userDeleteError: `Si è verificato un problema durante l'eliminazione dell'utente`,
        deactivateGroup: 'Disattiva gruppo',
        deactivateUser: 'Disattiva utente',
        deactivateGroupConfirm: 'Sei sicuro di voler disattivare il gruppo? Questa azione è irreversibile. Per riattivarlo dovrai contattare l\'amministratore di sistema',
        deactivateUserConfirm: 'Sei sicuro di voler disattivare l\'utente? Questa azione è irreversibile. Per riattivarlo dovrai contattare l\'amministratore di sistema',
        activateGroup: 'Attiva gruppo',
        activateUser: 'Attiva utente',
        activateGroupConfirm: 'Sei sicuro di voler attivare il gruppo?',
        activateUserConfirm: 'Sei sicuro di voler attivare l\'utente?',
        groupDeactivatedSuccess: 'Gruppo disattivato correttamente',
        groupDeactivateError: 'Si è verificato un problema durante la disattivazione del gruppo',
        groupActivatedSuccess: 'Gruppo attivato correttamente',
        groupActivateError: `Si è verificato un problema durante l'attivazione del gruppo`,
        userDeactivatedSuccess: 'Utente disattivato correttamente',
        userDeactivateError: `Si è verificato un problema durante la disattivazione dell'utente`,
        userActivatedSuccess: 'Utente attivato correttamente',
        userActivateError: `Si è verificato un problema durante l'attivazione dell'utente`,
        delete: 'Elimina',
        deactivate: 'Disattiva',
        activate: 'Attiva',
        cancel: 'Annulla',
        update: 'Aggiornamento',
        nameMandatory: 'Il nome è obbligatorio',
        lastNameMandatory: 'Il cognome è obbligatorio',
        emailMandatory: `L'email è obbligatoria`,
        usernameMandatory: 'Il nome utente è obbligatorio',
        authTypeMandatory: 'Il tipo di autenticazione è obbligatorio',
        groupSavedSuccess: 'Gruppo salvato correttamente',
        groupSaveError: 'Si è verificato un problema durante il salvataggio del gruppo',
        groupNotFound: 'Gruppo da salvare non trovato',
        userSavedSuccess: 'Utente salvato correttamente',
        userSaveError: `Si è verificato un problema durante il salvataggio dell'utente`,
        userNotFound: 'Utente da salvare non trovato',
        userProfile: `Scheda utente`,
        groupProfile: 'Gruppo',
        home: 'Home',
        profile: 'Profilo',
        editGroup: 'Modifica Gruppo',
        profileDetails: 'Dettagli Profilo',
        fullName: 'Nome Completo',
        email: 'Email',
        username: 'Nome Utente',
        active: 'Attivo',
        yourGroups: 'I Tuoi Gruppi',
        noGroups: 'Il tuo account non ha collegamenti con gruppi',
        noMembers: 'Nessun membro per questo gruppo',
        addRemoveGroups: `In questa sezione puoi aggiungere o rimuovere i gruppi dell'utente`,
        addRemoveGroupGroups: 'In questa sezione puoi aggiungere o rimuovere i gruppi del gruppo',
        addRemoveMembers: 'In questa sezione puoi aggiungere o rimuovere i membri del gruppo',
        newGroup: 'Nuovo gruppo',
        name: 'Nome',
        yourUsers: 'I Tuoi Utenti',
        connectedAccounts: 'Account Collegati',
        useLocalAccess: 'Usa accesso locale',
        useGoogleSSO: 'Usa Google SSO',
        useLDAPLogin: 'Usa LDAP per il login',
        useCASLogin: 'Usa CAS per il login',
        userCanUseLogin: `L'utente può utilizzare il login come Google, Microsoft e altri, senza inserire l'account locale`,
        notifications: 'Notifiche',
        billingUpdates: 'Aggiornamenti Fatturazione',
        newTeamMembers: 'Nuovi Membri del Team',
        completedProjects: 'Progetti Completati',
        newsletters: 'Newsletter',
        phone: 'Telefono',
        yes: 'Sì',
        no: 'No',
        basicInfo: 'Informazioni di base',
        deactivateAccount: 'Disattiva account',
        deactivateAccountMessage: 'Stai disattivando il tuo account',
        activateAccount: 'Attiva account',
        activateAccountMessage: 'Stai attivando il tuo account',
        deletingUserMessage: `Stai eliminando l'utente`,
        deletingUserIrreversibleAction: `Quest'azione e' irreversibile.Per successive azioni dovrai contattare l'amministrazione`,
        members: 'Membri',
        deactivatingGroupMessage: 'Stai disattivando il gruppo',
        activeGroup: 'Attiva il gruppo',
        activatingGroupMessage: 'In questo modo stai attivando il gruppo',
        deletingGroupMessage: 'Stai eliminando il gruppo',
        deletingGroupIrreversibleAction: `Quest'azione e' irreversibile.Per successive azioni dovrai contattare l'amministrazione`,
        noMembersForThisGroup: `Non ci sono membri per questo gruppo`,
        noLinkWithGroups: `Il tuo account non ha collegamenti con nessun gruppo`,
        password:`Password`,
        passwordMandatory:`E' obbligatorio inserire la password per poter procedere con la creazione dell'utente`,
        newUser:`Nuovo utente`,
        // Placeholders
        namePlaceholder: 'Nome',
        lastNamePlaceholder: 'Cognome',
        emailPlaceholder: 'E-Mail',
        usernamePlaceholder: 'Nome Utente',
        passwordPlaceholder: 'Password',
        passwordExpirationDate: 'Data Scadenza Password',
        passwordRequirements: 'Requisiti Password',
        passwordInfo: 'La password deve essere complessa e sicura',
        selectGroupToManage: 'Seleziona gruppo da gestire',
        assignedGroups: 'Gruppi Assegnati',
        remove: 'Rimuovi',
        noGroupsAssigned: 'Nessun gruppo assegnato',
        userPermissions: 'Permessi Utente',
        selectRightsNode: 'Seleziona nodo diritti'
   },
    
    en: {
        itemNotFound: 'Elemento non trovato',
        itemNotFoundMessage: 'The item is not found',
        goBack: 'Go back',
        success: 'Success',
        error: 'Error',
        close: 'Close',
        usersAndGroup: 'Users and Groups',
        groupEditor: 'Group editor',
        activeLabel: 'Active',
        disactiveLabel: 'Disactive',
        deleteGroup: 'Delete group',
        deleteUser: 'Delete user',
        deleteGroupConfirm: 'Are you sure that you want to delete the group? This action is irreversible.',
        deleteUserConfirm: 'Are you sure that you want to delete the user? This action is irreversible.',
        groupDeletedSuccess: 'Group deleted successfully',
        groupDeleteError: 'We had some problem to delete the group',
        userDeletedSuccess: 'User deleted successfully',
        userDeleteError: 'We had some problem to delete the user',
        deactivateGroup: 'Deactivate group',
        deactivateUser: 'Deactivate user',
        deactivateGroupConfirm: 'Are you sure that you want to deactivate the group? This action is irreversible. To activate again you need to contact the system Admin',
        deactivateUserConfirm: 'Are you sure that you want to deactivate the user? This action is irreversible. To activate again you need to contact the system Admin',
        activateGroup: 'Activate group',
        activateUser: 'Activate user',
        activateGroupConfirm: 'Are you sure that you want to activate the group?',
        activateUserConfirm: 'Are you sure that you want to activate the user?',
        groupDeactivatedSuccess: 'Group deactivated successfully',
        groupDeactivateError: 'We had some problem to deactivate the group',
        groupActivatedSuccess: 'Group activated successfully',
        groupActivateError: 'We had some problem to activate the group',
        userDeactivatedSuccess: 'User deactivated successfully',
        userDeactivateError: 'We had some problem to deactivate the user',
        userActivatedSuccess: 'User activated successfully',
        userActivateError: 'We had some problem to activate the user',
        delete: 'Delete',
        deactivate: 'Deactivate',
        activate: 'Activate',
        cancel: 'Cancel',
        update: 'Update',
        nameMandatory: 'Name is mandatory',
        lastNameMandatory: 'Last name is mandatory',
        emailMandatory: 'Email is mandatory',
        usernameMandatory: 'Username is mandatory',
        authTypeMandatory: 'Authentication type is mandatory',
        groupSavedSuccess: 'Group saved successfully',
        groupSaveError: 'We had some problem to save the group',
        groupNotFound: 'Group to save not found',
        userSavedSuccess: 'User saved successfully',
        userSaveError: 'We had some problem to save the user',
        userNotFound: 'User to save not found',
        userProfile: 'User Profile',
        groupProfile: 'Group Profile',
        home: 'Home',
        profile: 'Profile',
        editGroup: 'Edit Group',
        profileDetails: 'Profile Details',
        fullName: 'Full Name',
        email: 'E-Mail',
        username: 'Username',
        active: 'Active',
        yourGroups: 'Your Groups',
        noGroups: 'Your account don\'t have any link with groups',
        noMembers: 'No members for this group',
        addRemoveGroups: 'In this section you can add or remove the user groups',
        addRemoveGroupGroups: 'In this section you can add or remove the group\'s group',
        addRemoveMembers: 'In this section you can add or remove members to the group',
        newGroup: 'New group',
        name: 'Name',
        yourUsers: 'Your Users',
        connectedAccounts: 'Connected Accounts',
        useLocalAccess: 'Use local access',
        useGoogleSSO: 'Use Google SSO',
        useLDAPLogin: 'Use LDAP for login',
        useCASLogin: 'Use CAS for login',
        userCanUseLogin: 'User can use login like Google, Microsoft and other, without enter with local account',
        notifications: 'Notifications',
        billingUpdates: 'Billing Updates',
        newTeamMembers: 'New Team Members',
        completedProjects: 'Completed Projects',
        newsletters: 'Newsletters',
        phone: 'Phone',
        yes: 'Yes',
        no: 'No',
        basicInfo: 'Basic Info',
        deactivateAccount: 'Deactivate account',
        deactivateAccountMessage: 'You are deactivating your account',
        activateAccount: 'Activate account',
        activateAccountMessage: 'You are activating your account',
        deletingUserMessage: 'You are deleting the User',
        deletingUserIrreversibleAction: 'This action is irreversible. For future actions you need to contact administration',
        members: 'Members',
        deactivatingGroupMessage: 'You are deactivating the group',
        activeGroup: 'Activate the group',
        activatingGroupMessage: 'By doing so you are activating the group',
        deletingGroupMessage: 'You are deleting the group',
        deletingGroupIrreversibleAction: 'This action is irreversible. For future actions you need to contact administration',
        noMembersForThisGroup: 'There are no members for this group',
        noLinkWithGroups: 'Your account has no links with any groups',
        // Placeholders
        namePlaceholder: 'Name',
        lastNamePlaceholder: 'Last Name',
        emailPlaceholder: 'E-Mail',
        usernamePlaceholder: 'Username',
        passwordPlaceholder: 'Password',
        passwordExpirationDate: 'Password Expiration Date',
        passwordRequirements: 'Password Requirements',
        passwordInfo: 'Password must be complex and secure',
        selectGroupToManage: 'Select group to manage',
        assignedGroups: 'Assigned Groups',
        remove: 'Remove',
        noGroupsAssigned: 'No groups assigned',
        userPermissions: 'User Permissions',
        selectRightsNode: 'Select rights node',
        deletingUserIrreversibleActionOld: `This action is irreversible. For any other action  you need to contact the administrator`,
        members: 'Members',
        deactivatingGroupMessage: 'You are deactivating the group',
        activeGroup: 'Activate the group',
        activatingGroupMessage: 'In this way you are activating the group',
        deletingGroupMessage: 'You are deleting the group',
        deletingGroupIrreversibleAction: 'This action is irreversible. For any other action  you need to contact the administrator',
        noMembersForThisGroup: `No members for this group`,
        noLinkWithGroups: `Your account don't have any link with any group`,
        password:`Password`,
        passwordMandatory:`You need to insert the password to proceed with the creation of the account`,
        newUser:`New User`
    }
}; 